import React from "react";
import { Button } from "../ui/button";
import { Sparkles, Play, X, Database, Loader2 } from "lucide-react";

export const SmartQueryConfirm = ({ smartQuery, question, onRun, onCancel, running }) => {
  if (!smartQuery) return null;
  return (
    <div
      data-testid="smart-query-confirm"
      className="rounded-2xl border border-violet-200 bg-gradient-to-br from-violet-50 via-white to-amber-50 p-5 shadow-sm"
    >
      <div className="flex items-start justify-between gap-3">
        <div className="flex items-start gap-3 min-w-0">
          <span className="inline-flex items-center justify-center w-9 h-9 rounded-xl bg-violet-100 text-violet-700 flex-shrink-0">
            <Database className="w-4 h-4" />
          </span>
          <div className="min-w-0">
            <div className="flex items-center gap-2 mb-1">
              <span className="text-[10px] uppercase tracking-wider font-semibold text-violet-700">
                Smart Query
              </span>
              <span className="text-[10px] text-slate-400">·</span>
              <span className="text-[10px] uppercase tracking-wider font-medium text-slate-500">
                No template needed
              </span>
            </div>
            <h3 className="text-base font-semibold text-slate-900 leading-snug">
              {smartQuery.title || "Custom query"}
            </h3>
            {question && (
              <p className="text-xs text-slate-500 mt-0.5 italic">"{question}"</p>
            )}
          </div>
        </div>
        <button
          onClick={onCancel}
          disabled={running}
          className="p-1.5 rounded-md text-slate-400 hover:text-slate-700 hover:bg-slate-100 transition"
          title="Cancel"
          data-testid="smart-query-cancel"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
      <div className="mt-4 rounded-lg border border-slate-200 bg-white/80 p-3">
        <div className="text-[10px] uppercase tracking-wider font-semibold text-slate-500 mb-1.5">
          Plan
        </div>
        <ul className="space-y-1">
          {(smartQuery.plan_lines || []).map((line, i) => (
            <li key={i} className="text-sm text-slate-700 font-mono flex items-center gap-2">
              <span className="text-violet-400 text-xs">›</span>
              <span>{line}</span>
            </li>
          ))}
        </ul>
      </div>
      <div className="mt-4 flex items-center justify-between gap-3 flex-wrap">
        <p className="text-xs text-slate-500 max-w-md">
          Numbers come from a deterministic query. AI never invents.
          Result will be saved as a snapshot you can export.
        </p>
        <Button
          data-testid="smart-query-run"
          onClick={onRun}
          disabled={running}
          className="bg-violet-600 hover:bg-violet-700 text-white"
        >
          {running ? (
            <>
              <Loader2 className="w-4 h-4 animate-spin mr-1.5" />
              Running…
            </>
          ) : (
            <>
              <Play className="w-4 h-4 mr-1.5" />
              Run Smart Query
            </>
          )}
        </Button>
      </div>
    </div>
  );
};

export default SmartQueryConfirm;
